export default [
    {
        path: '/webview/webview',
        component: (resolve) => require(['@/components/webview/WebView'],resolve),
        meta: {
            title:''
        }
    },
    {
        path: '/webview/webview2',
        component: (resolve) => require(['@/components/webview/WebView2'],resolve),
        meta: {
            title:''
        }
    },

]


// WEBPACK FOOTER //
// ./src/router/webview.js